import { useEffect, useState } from 'react'

/**
 * Honour the OS "reduce motion" setting. Shared by every Quick Study surface with a
 * decorative animation — the chat typing reveal (MessageRow) and the Compare-segments
 * plot-swap transition (PlotRenderer) — so the reduced-motion contract never drifts
 * between copies (there was a second module-local copy in each before this hoist).
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false)
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
    setReduced(mq.matches)
    const onChange = () => setReduced(mq.matches)
    mq.addEventListener?.('change', onChange)
    return () => mq.removeEventListener?.('change', onChange)
  }, [])
  return reduced
}
